import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useNavigate, useLocation } from 'react-router-dom';
import './candidatesearch.css';
import positionIcon from '../../../../assets/images/Ic_work position.png';
import industryIcon from '../../../../assets/images/Ic_work company.png';
import locIcon from '../../../../assets/images/Ic_location1.png';
import salaryIcon from '../../../../assets/images/Ic_amount.png';
import ClientCandidateService from '../../../../services/client-services/clientCandidateService';
import _ from 'lodash';
import { CandidateService } from '../../../../services/candidateService';
import { serverConfig } from '../../../../services/server-config';
import axios from 'axios';
import PersonImage from '../../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import CandidateSearchForm from './candidatesearchform';
import gridIcon from '../../../../assets/images/Ic_coloum.png';
import linesIcon from '../../../../assets/images/Ic_list.png';
import profilebackButtonIcon from '../../../../assets/images/Ic_search_back.png';

const CandidateSearch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [viewMode, setViewMode] = useState('grid');
  const [loading, setLoading] = useState(false);
  const [allFilteredResults, setAllFilteredResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(9);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCandidates, settotalCandidates] = useState(0);

  const [isMediumScreen, setIsMediumScreen] = useState(false);
  const [showResultsSection, setShowResultsSection] = useState(false);
  const [juniorerrorMessage, setJuniorErrorMessage] = useState('');
  const [hasSearched, setHasSearched] = useState(false);

  const fetchCandidates = async (searchQuery = {}, page = 0) => {
    setLoading(true);
    let isActive = true;

    try {
      const requestBody = {
        page,
        size: pageSize,
        ...(searchQuery?.designation && { designation: searchQuery.designation }),
        ...(searchQuery?.industries?.length && {
          industrySubcategories: searchQuery.industries.map(i => ({
            fieldValue: i.fieldValue,
            subcategory: i.subcategory || ""
          }))
        }),
        ...(searchQuery?.functions?.length && {
          functions: searchQuery.functions.map(f => ({
            fieldValue: f.fieldValue,
            subcategory: f.subcategory || ""
          }))
        }),
        ...(searchQuery?.juniorProfile && {
          juniorProfile: searchQuery.juniorProfile,
        }),
        // ...(searchQuery?.city && { location: searchQuery.city }),
        // ...(searchQuery?.experience && {
        //   yearsOfExp: parseInt(searchQuery.experience, 10),
        // }),
        ...(searchQuery?.locations?.length && { locations: searchQuery.locations }),
        ...(searchQuery?.yearsOfExpMin !== '' && searchQuery?.yearsOfExpMin !== undefined && {
          yearsOfExpMin: Math.max(parseInt(searchQuery.yearsOfExpMin, 10) || 0, 0),
        }),
        ...(searchQuery?.yearsOfExpMax !== '' && searchQuery?.yearsOfExpMax !== undefined && {
          yearsOfExpMax: Math.max(parseInt(searchQuery.yearsOfExpMax, 10) || 0, 0),
        }),


        ...(searchQuery?.specialisation && {
          specialisation: searchQuery.specialisation,
        }),
        ...(searchQuery?.ctcMin && {
          ctcMin: Math.max(parseInt(searchQuery.ctcMin, 10) || 0, 0),
        }),
        ...(searchQuery?.ctcMax && {
          ctcMax: Math.max(parseInt(searchQuery.ctcMax, 10) || 0, 0),
        }),
      };

      const response = await ClientCandidateService.osSearch(requestBody);

      const candidateData = response?.data?.clientCandidateDTOs || [];
      const total = response?.data?.pageCount || 0;
      const totalcandidates = response?.data?.totalCount || 0;

      const mappedCandidates = candidateData.map((candidateDTO) => {
        const outerCandidate = candidateDTO?.candidate || {};
        const innerCandidate = outerCandidate?.candidate || {};
        const personalDetails = innerCandidate?.personalDetails || {};
        const workExperience = innerCandidate?.workExperience || {};
        const currentRole = workExperience?.currentRole || {};
        const compensationDetails = innerCandidate?.compensationDetails || {};
        const currentAddress = personalDetails?.currentAddress || {};
        const shortlistDetailsArray = Array.isArray(candidateDTO?.shortlistDetails)
          ? candidateDTO.shortlistDetails
          : [];

        const allHistoryNodes = shortlistDetailsArray.flatMap(
          d => d?.shortlistHistory?.shortlistHistoryNodes || []
        );

        const activeNode = allHistoryNodes.find(n => n.active === true);
        const shortlistStatus = candidateDTO?.currentStatus || activeNode?.shortlistStatus || '';

        return {
          candidateId: outerCandidate?.candidateId || '',
          salutation: personalDetails?.salutation || '',
          firstName: personalDetails?.firstName || '',
          middleName: personalDetails?.middleName || '',
          lastName: personalDetails?.lastName || '',
          name: `${personalDetails?.salutation ? personalDetails.salutation + ' ' : ''}${personalDetails?.firstName || ''} ${personalDetails?.middleName || ''} ${personalDetails?.lastName || ''}`.trim(),
          experience: workExperience?.totalYrs ? `${workExperience.totalYrs} years` : '',
          position: currentRole?.designation || '',
          company: currentRole?.orgName || '',
          industry: currentRole?.industry || '',
          location: currentRole?.location || '',
          salary: compensationDetails?.total ? `₹ ${compensationDetails.total} L / annum` : '',
          // shortlistStatus: activeNode?.shortlistStatus || '',
          // shortlistStatus,
          displayPicPath: personalDetails?.displayPic?.[0]?.path || null,
          personImage: PersonImage,
          status: candidateDTO?.candidate?.status || '',
          viewed: Boolean(candidateDTO?.viewed),


        };
      });


      setAllFilteredResults(mappedCandidates);
      setFilteredResults(mappedCandidates.slice(0, pageSize));
      setTotalPages(total);
      settotalCandidates(totalcandidates);
      setLoading(false);

      setTimeout(() => {
        mappedCandidates.forEach(async (candidate) => {
          if (!candidate.displayPicPath) return;

          const candidateId = candidate.candidateId;
          const imageUrl = `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${candidate.displayPicPath}`;

          try {
            const response = await axios.get(imageUrl, {
              headers: CandidateService.getAuthHeader(),
              responseType: 'blob',
            });

            if (!isActive) return;

            if (response?.data) {
              const blobUrl = URL.createObjectURL(response.data);

              setFilteredResults((prev) =>
                prev.map((c) =>
                  c.candidateId === candidateId ? { ...c, personImage: blobUrl } : c
                )
              );
            }
          } catch (error) {
            console.error(`Error fetching image for ${candidateId}:`, error.message);
          }
        });
      }, 0);
    } catch (error) {
      setLoading(false);

      if (error?.response?.status === 403) {
        const backendMsg = error.response?.data?.message || '';

        const uiMessage = backendMsg.includes('Junior profile not opted')
          ? 'Junior profiles are not enabled for your account. Please contact administrator.'
          : 'You are not authorized to perform this action.';
        setJuniorErrorMessage(uiMessage);
        setFilteredResults([]);
        setTotalPages(0);
        settotalCandidates(0);
        return;
      }

      console.error('Error fetching candidates:', error);
    }


    return () => {
      isActive = false;
      filteredResults.forEach((c) => {
        if (c.personImage?.startsWith('blob:')) {
          URL.revokeObjectURL(c.personImage);
        }
      });
    };
  };

  useEffect(() => {
    const savedResults = sessionStorage.getItem('filteredResults');
    if (savedResults) {
      setFilteredResults(JSON.parse(savedResults));
    }
  }, []);


  useEffect(() => {
    const savedState = location.state;
    if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
      sessionStorage.clear();
      setSearchQuery({});
      setFilteredResults([]);
      setCurrentPage(0);
      setTotalPages(0);
      setViewMode('grid');
      setShowResultsSection(false);
      return;
    }

    if (savedState) {
      setSearchQuery(JSON.parse(savedState.searchFilters));
      setFilteredResults(JSON.parse(savedState.filteredResults) || []);
      setCurrentPage(Number(savedState.currentPage) || 0);
      setTotalPages(Number(savedState.totalPages) || 0);
      setViewMode(savedState.viewMode || 'grid');
      setHasSearched(true);
      return;
    }

    const savedFilters = sessionStorage.getItem('searchFilters');
    const savedResults = sessionStorage.getItem('filteredResults');
    const savedPage = sessionStorage.getItem('currentPage');
    const savedTotalPages = sessionStorage.getItem('totalPages');
    const savedViewMode = sessionStorage.getItem('viewMode');
    const savedShowResults = sessionStorage.getItem('showResultsSection');

    if (savedFilters && savedResults) {
      setSearchQuery(JSON.parse(savedFilters));
      setFilteredResults(JSON.parse(savedResults) || []);
      setCurrentPage(savedPage ? Number(savedPage) : 0);
      setTotalPages(savedTotalPages ? Number(savedTotalPages) : 0);
      setViewMode(savedViewMode || 'grid');
      setShowResultsSection(savedShowResults ? JSON.parse(savedShowResults) : false);
      setHasSearched(true);
    } else {
      setSearchQuery({});
      setFilteredResults([]);
      setCurrentPage(0);
      setTotalPages(0);
      setViewMode('grid');
      setShowResultsSection(false);
    }
  }, [location.state]);

  const resultsRef = useRef(null);

  const handleSearchSubmit = (query) => {
    if (!query || Object.keys(query).length === 0) {
      setHasSearched(false);
      setSearchQuery({});
      setFilteredResults([]);
      setCurrentPage(0);
      setTotalPages(0);
      setShowResultsSection(false);
      sessionStorage.removeItem("searchFilters");
      sessionStorage.removeItem("filteredResults");
      return;
    }

    const sanitizedQuery = {
      ...query,
      industries: Array.isArray(query.industries)
        ? query.industries
        : [],
    };
    setHasSearched(true);
    setSearchQuery(sanitizedQuery);

    const allEmpty = Object.values(sanitizedQuery).every((val) => {
      if (Array.isArray(val)) return val.length === 0;
      if (val === null || val === undefined) return true;
      if (typeof val === "string") return val.trim() === "";
      return false;
    });

    if (allEmpty) {
      setSearchQuery({});
      setFilteredResults([]);
      setCurrentPage(0);
      setTotalPages(0);
      setShowResultsSection(false);
      sessionStorage.removeItem("searchFilters");
      sessionStorage.removeItem("filteredResults");
      return;
    }

    sessionStorage.setItem("searchFilters", JSON.stringify(sanitizedQuery));
    sessionStorage.removeItem("filteredResults");
    sessionStorage.removeItem("totalPages");

    setSearchQuery(sanitizedQuery);
    setCurrentPage(0);
    setShowResultsSection(true);

    fetchCandidates(sanitizedQuery, 0).then(() => {
      if (resultsRef.current) {
        resultsRef.current.scrollIntoView({ behavior: "smooth" });
      }
    });
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const current = currentPage + 1;

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);

      if (current > 3) {
        pageNumbers.push('...');
      }

      const start = Math.max(2, current - 1);
      const end = Math.min(totalPages - 1, current + 1);

      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }

      if (current < totalPages - 2) {
        pageNumbers.push('...');
      }
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  useEffect(() => {
    if (!hasSearched) return;
    if (Object.keys(searchQuery).length === 0) return;

    fetchCandidates(searchQuery, currentPage);
  }, [searchQuery, currentPage, hasSearched]);


  const renderNoResultsMessage = () => {
    if (filteredResults.length === 0 && totalPages === 0) {
      return <div className="no-candidates-message">No Candidates Found</div>;
    } else {
      return null;
    }
  };
  const handleViewToggle = (mode) => {
    setViewMode(mode);
  };


  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMediumScreen(width >= 768 && width <= 1200);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const inlineRowStyle = isMediumScreen
    ? {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      justifyContent: "center",
      margin: "0",
    }
    : undefined;

  return (
    <div className="fluid-container" style={{ minHeight: '600px' }}>
      <div className="searchcandidate-top-container d-flex flex-column align-items-center text-center py-3">
        <div className="searchcandidate-page-content-wrapper">
          <div className="searchcandidate-breadcrumb ">
            <p style={{ color: '#FFFFFF', fontSize: '20px', marginRight: '30px' }}>Search Candidate</p>
            <span style={{ color: '#99A4AF', textDecoration: 'none', marginLeft: '20px' }}>
              <span
                onClick={() => {
                  sessionStorage.clear();
                  navigate(-1);
                }}
                style={{ cursor: "pointer", marginLeft: "10px" }}
              >
                <img src={profilebackButtonIcon} alt="Back" className="breadcrumb-back-icon" />
                &nbsp; Back
              </span>
              <span style={{ marginLeft: '10px' }}>/</span>
              <span style={{ color: '#99A4AF', textDecoration: 'none', marginLeft: '10px' }}>
                Candidate
              </span>
              <span style={{ marginLeft: '10px' }}> /</span>
              <span style={{ marginLeft: '10px' }}> Search</span>
            </span>
          </div>
        </div>
      </div>
      <CandidateSearchForm onSubmit={handleSearchSubmit} juniorerrorMessage={juniorerrorMessage} setJuniorErrorMessage={setJuniorErrorMessage} hasSearched={hasSearched} />
      {showResultsSection && (
        <>
          <div ref={resultsRef}>
            <div className="searchcandidate-results-controls">
              <div className="searchcandidate-results-count">
                Search Result <span className="searchcandidate-result-count-number">({totalCandidates})</span>
              </div>
              <div className="searchcandidate-filter-sort-container">

                <div className="searchcandidate-view-toggle-container">
                  <div className="searchcandidate-view-toggle-icons">
                    <div
                      className={`searchcandidate-icon-container ${viewMode === 'grid' ? 'active' : ''}`}
                      onClick={() => handleViewToggle('grid')}
                    >
                      <img
                        src={gridIcon}
                        alt="Grid Icon"
                        className={`searchcandidate-icon ${viewMode === 'grid' ? 'active-icon' : ''}`}
                      />
                    </div>
                    <div
                      className={`searchcandidate-icon-container ${viewMode === 'list' ? 'active' : ''}`}
                      onClick={() => handleViewToggle('list')}
                    >
                      <img
                        src={linesIcon}
                        alt="Lines Icon"
                        className={`searchcandidate-icon ${viewMode === 'list' ? 'active-icon' : ''}`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {loading ? (
              <div className="searchcandidate-loader-container">
                <div className="searchcandidate-loader"></div>
              </div>
            ) : (
              <div className="cards-container mt-4">
                {renderNoResultsMessage()}
                {filteredResults.length > 0 && (
                  <div
                    className={`row ${viewMode === 'grid' ? (
                      `row-cols-1 row-cols-md-2 ${filteredResults.length === 2 ? 'row-cols-lg-2' : 'row-cols-lg-3'}`
                    ) : ''}`}
                    style={inlineRowStyle}
                  >
                    {filteredResults.map((card, index) => (
                      <div className="col mb-4" key={index}>
                        <a
                          href={`/client/candidate-information?candidateId=${card.candidateId}`}
                          className="text-decoration-none"
                          onClick={(e) => {
                            e.preventDefault();
                            sessionStorage.setItem('searchFilters', JSON.stringify(searchQuery));
                            sessionStorage.setItem('filteredResults', JSON.stringify(filteredResults));
                            sessionStorage.setItem('currentPage', currentPage);
                            sessionStorage.setItem('totalPages', totalPages);
                            sessionStorage.setItem('viewMode', viewMode);
                            sessionStorage.setItem('searchFormData', JSON.stringify(searchQuery));
                            sessionStorage.setItem('showResultsSection', JSON.stringify(true));

                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            window.location.href = `/client/candidate-information?candidateId=${card.candidateId}`;
                          }}
                        >
                          <div
                            className={`searchcandidate-result-card
    ${viewMode === 'grid'
                                ? 'searchcandidate-grid-card'
                                : 'searchcandidate-list-card'}
    ${card.viewed ? 'candidate-viewed' : ''}
  `}
                          >


                            {card.status && (
                              <div className="candidate-status-wrapper">
                                {card.status === 'VALIDATED' ? (
                                  <i
                                    className="fas fa-check-circle candidate-status-icon validated"
                                  />
                                ) : (
                                  <i
                                    className="fas fa-clock candidate-status-icon in-progress"
                                  />
                                )}

                                <span className="candidate-status-tooltip">
                                  {card.status === 'VALIDATED'
                                    ? 'Verified'
                                    : 'Verification In Progress'}
                                </span>
                              </div>
                            )}

                            <div className="searchcandidate-card-header d-flex justify-content-between align-items-start">
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                  <img src={card.personImage} alt="Person Icon" className="searchcandidate-person-icon" />
                                  <div className="searchcandidate-card-header-text">
                                    <p className="searchcandidate-name truncate-text">
                                      <span>{card.salutation ? `${card.salutation} ` : ''}</span>
                                      <span >{card.firstName} </span>
                                      <span>{card.lastName}</span>
                                    </p>
                                    <p>Experience: {card.experience}</p>
                                  </div>
                                </div>
                                {/* <p
                                  className={`searchcandidate-shortlist-status ${card.shortlistStatus.toLowerCase()}`}
                                  style={{ marginLeft: 'auto' }}
                                >
                                  {card.shortlistStatus}
                                </p> */}
                              </div>
                              {viewMode === 'list' && (
                                <>
                                  <hr className="searchcandidate-card-divider" />
                                  <div className="searchcandidate-card-skills">
                                    {/* <p className="searchcandidate-skill-item">Financial Reporting</p>
                          <span className="searchcandidate-skill-divider"></span>
                          <p className="searchcandidate-skill-item">Plant Accounting</p>
                          <span className="searchcandidate-skill-divider"></span>
                          <p className="searchcandidate-skill-item">Manpower Handling</p>
                          <span className="searchcandidate-skill-divider"></span>
                          <p className="searchcandidate-skill-item">Maintainance</p> */}
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="searchcandidate-card-content mt-3">
                              <div className="searchcandidate-info-item">
                                <img src={positionIcon} alt="Position Icon" className="searchcandidate-info-icon" />
                                <p className="searchcandidate-info-item-p truncate-text" >{card.position}</p>
                              </div>
                              <div className="searchcandidate-info-item">
                                <img src={industryIcon} alt="Company Icon" className="searchcandidate-info-icon" />
                                <p className="searchcandidate-info-item-p truncate-text">{card.company}</p>
                              </div>
                              <div className="searchcandidate-info-item">
                                <img src={industryIcon} alt="Industry Icon" className="searchcandidate-info-icon" />
                                <p className="searchcandidate-info-item-p truncate-text">{card.industry}</p>
                              </div>
                              <div className="searchcandidate-info-item">
                                <img src={locIcon} alt="Location Icon" className="searchcandidate-info-icon" />
                                <p className="searchcandidate-info-item-p truncate-text">{card.location}</p>
                              </div>
                              <div className="searchcandidate-info-item">
                                <img src={salaryIcon} alt="Salary Icon" className="searchcandidate-info-icon" />
                                <p className="searchcandidate-info-item-p truncate-text">{card.salary}</p>
                              </div>
                            </div>
                            {viewMode === 'grid' && (
                              <>
                                {/* <hr className="searchcandidate-card-divider" /> */}
                                <div className="searchcandidate-card-skills">
                                  {/* <p className="searchcandidate-skill-item">Financial Reporting</p>
                        <span className="searchcandidate-skill-divider"></span>
                        <p className="searchcandidate-skill-item">Plant Accounting</p> */}
                                </div>
                                <div className="searchcandidate-card-skills">
                                  {/* <p className="searchcandidate-skill-item">Manpower Handling</p>
                        <span className="searchcandidate-skill-divider"></span>
                        <p className="searchcandidate-skill-item">Maintainance</p> */}
                                </div>
                              </>
                            )}
                            <div className="candidate-view-profile-overlay">
                              View Profile
                              <i className="fas fa-arrow-right" style={{ marginLeft: "10px", fontSize: '15px' }}></i>
                            </div>

                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {/* Pagination Controls */}
            {totalPages > 1 && filteredResults.length > 0 && (
              <div className="d-flex justify-content-center my-3">
                <div className="pagination-container">
                  <button onClick={() => setCurrentPage(0)} disabled={currentPage === 0}>
                    {'<<'}
                  </button>
                  <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))} disabled={currentPage === 0}>
                    {'<'}
                  </button>

                  {renderPageNumbers().map((page, index) => (
                    <button
                      key={index}
                      className={`border rounded p-1 ${currentPage + 1 === page ? 'active' : ''}`}
                      onClick={() => {
                        if (typeof page === 'number') setCurrentPage(page - 1);
                      }}
                      disabled={typeof page !== 'number'}
                    >
                      {page}
                    </button>
                  ))}

                  <button
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
                    disabled={currentPage >= totalPages - 1}
                  >
                    {'>'}
                  </button>
                  <button onClick={() => setCurrentPage(totalPages - 1)} disabled={currentPage >= totalPages - 1}>
                    {'>>'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CandidateSearch;